document.addEventListener("DOMContentLoaded", function() {
    var button = document.querySelector('.shop-coffee.newsletter');
    var formDiv = document.querySelector('.appearo-formo');
  
    if (button && formDiv) {
      button.addEventListener('click', function() {
        formDiv.classList.toggle('appear'); // Replace 'your-class-name' with the class you want to add
      });
    }
  });